import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import imgExpand from '../../assets/images/expand.png';
// import imgDownload from '../../assets/images/download.png';

import { LAYOUT, MIN_WIDTH } from '../Layout/enums';

import './styles.css';

const getComponent = layout => ({
  type,
  display,
  viewLink,
  // downloadLink,
  date,
  showViewIcon,
}) => {
  let styleSuff = '';
  switch (layout) {
    case LAYOUT.TAB:
      styleSuff = 'Tab';
      break;
    case LAYOUT.MOB:
      styleSuff = 'Mob';
      break;
    // no default
  }
  if (layout !== LAYOUT.MOB) {
    return (
      <div styleName={`docItem${styleSuff}`}>
        <div styleName="docRow">
          <div styleName="docCol">
            <div styleName={`docType${styleSuff}`}>{display}</div>
            <div styleName="docDate">{date}</div>
          </div>
          <div styleName="docColImages">
            {showViewIcon ?
              <a styleName="imageLink" href={viewLink} target="_blank">
                <img
                  alt={`View ${type} for ${date}`}
                  styleName={`imgExpand${styleSuff}`}
                  id="imgExpand"
                  src={imgExpand}
                  title="View document"
                />
              </a> : null}
            {/* <a styleName="imageLink" href={downloadLink} target="_blank">
              <img
                alt={`Download ${type} for ${date}`}
                styleName={`imgExpand${styleSuff}`}
                id="imgExpand"
                src={imgDownload}
                type="image"
                title="Download"
              />
            </a> */}
          </div>
        </div>
      </div>
    );
  }
  // Mobile layout
  return (
    <div>
      <div styleName={`docDate${styleSuff}`}>{date}</div>
      <div styleName={`docItem${styleSuff}`}>
        <div styleName="docRow">
          <div styleName={`docType${styleSuff}`}>{display}</div>
          {showViewIcon ?
            <a href={viewLink} target="_blank">
              <img
                alt={`View ${type} for ${date}`}
                styleName={`imgExpand${styleSuff}`}
                id="imgExpand"
                src={imgExpand}
              />
            </a> : null}
        </div>
        {!showViewIcon ?
          <div styleName="dlUnavailMsg">This document cannot be viewed on mobile devices.</div> : null}
      </div>
    </div>
  );
};

export const Desktop = getComponent(LAYOUT.DESK);

export const Tablet = getComponent(LAYOUT.TAB);

export const Mobile = getComponent(LAYOUT.MOB);


class DocItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canceled: false,
    };

    this.onCancel = this.onCancel.bind(this);
  }

  onCancel() {
    this.setState({ canceled: true });
  }

  render() {
    if (this.state.canceled) {
      return <div />;
    }

    const propsToPass = {
      ...this.props,
      onCancel: this.onCancel,
    };
    return (
      <div>
        <MediaQuery
          minWidth={MIN_WIDTH.DESK}
        >
          <Desktop
            {...propsToPass}
          />
        </MediaQuery>
        <MediaQuery
          minWidth={MIN_WIDTH.TAB}
          maxWidth={MIN_WIDTH.DESK - 1}
        >
          <Tablet
            {...propsToPass}
          />
        </MediaQuery>
        <MediaQuery
          maxWidth={MIN_WIDTH.TAB - 1}
        >
          <Mobile
            {...propsToPass}
          />
        </MediaQuery>
      </div>
    );
  }
}


DocItem.propTypes = {
  type: PropTypes.string.isRequired,
  viewLink: PropTypes.string.isRequired,
  downloadLink: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  showViewIcon: PropTypes.bool.isRequired,
};

export default DocItem;



// WEBPACK FOOTER //
// ./src/components/AccountDocs/DocItem.js